import React, { useEffect, useState } from "react";
import { Row, Col, Modal, Button } from '../../ui/ot'
import { useCRUDController } from "./../../ui/classify_structure/CRUDController";


const BibMarc21InfoModal = ({
    bib_title,
    bib_biblionumber
}) => {
    const bib_controller = useCRUDController({ apiRoute: "/koha/bib" })
    useEffect(() => {
        bib_controller.getData({
            biblionumber: bib_biblionumber,
            marcdata: "json"
        })
    }, [])
    return (<Row>
        <Col>
            <Button type="link" onClick={() => {

                Modal.info({
                    width: '1000px',
                    title: bib_title,
                    okText: "關閉",
                    content: <>
                        {
                            bib_controller.ResponseData.map((value) => {
                                return (
                                    <Row>
                                        <Col span={24}>
                                            <Row>
                                                <Col span={24}>
                                                    <Row>
                                                        <Col span={3}>
                                                            leader
                                                        </Col>
                                                        <Col span={21}>
                                                            {value?.metadata?.leader}
                                                        </Col>
                                                    </Row>
                                                </Col>
                                            </Row>
                                        </Col>
                                        <Col span={24}>
                                            <Row>
                                                {value?.metadata?.controlfield.filter((ele)=>!!ele?.text).map((field) => {
                                                    return (
                                                        <Col span={24}>
                                                            <Row>
                                                                <Col span={3}>
                                                                    {field?.tag}
                                                                </Col>
                                                                <Col span={21}>
                                                                    {field?.text}
                                                                </Col>
                                                            </Row>
                                                        </Col>
                                                    )
                                                })}
                                            </Row>
                                        </Col>
                                        <Col span={24}>
                                            <Row gutter={[8, 8]}>
                                                {value?.metadata?.datafield.map((field) => {
                                                    return (
                                                        <Col span={24}>
                                                            <Row>
                                                                <Col span={3}>
                                                                    <Row gutter={[4, 4]}>
                                                                        <Col>
                                                                            {field?.tag}
                                                                        </Col>
                                                                        <Col>
                                                                            {field?.ind1}
                                                                        </Col>
                                                                        <Col>
                                                                            {field?.ind2}
                                                                        </Col>
                                                                    </Row>
                                                                </Col>
                                                                <Col span={21}>
                                                                    <Row>
                                                                        {
                                                                            field?.subfield?.map((sub) => {
                                                                                return (
                                                                                    <Col span={24}>
                                                                                        <Row gutter={[4, 4]} >
                                                                                            <Col>
                                                                                                {sub?.code}
                                                                                            </Col>
                                                                                            <Col>
                                                                                                {sub?.text}
                                                                                            </Col>
                                                                                        </Row>
                                                                                    </Col>
                                                                                )
                                                                            })
                                                                        }
                                                                    </Row>
                                                                </Col>
                                                            </Row>
                                                        </Col>
                                                    )
                                                })}
                                            </Row>
                                        </Col>
                                    </Row>
                                )
                            })


                        }
                    </>

                })
            }}>
                Marc
            </Button>
        </Col>
    </Row>)
}
export default BibMarc21InfoModal